import { brandStorage as localStorage } from '@/utils/brandSession';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { BACKEND_URL } from './config';
import { redirectExpiredSession } from './sessionRedirect';
import { currentSite } from './brandSession';

console.log('🔗 API Backend URL:', BACKEND_URL);

// Create axios instance
const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 30000,  // Increased timeout for production
});

// Configure axios-retry for handling 502/503/504 errors (backend warming up)
axiosRetry(api, {
  retries: 3, // Number of retry attempts
  retryDelay: (retryCount) => {
    console.log(`🔄 API retry attempt ${retryCount}...`);
    return retryCount * 1500; // 1.5s, 3s, 4.5s delays
  },
  retryCondition: (error) => {
    if (error.config?.skipRetry) return false;
    // Retry on network errors or 5xx errors (especially 502, 503, 504)
    const isNetworkError = axiosRetry.isNetworkError(error);
    const isRetryableError = error.response && [502, 503, 504].includes(error.response.status);
    
    if (isNetworkError || isRetryableError) {
      console.log(`⚠️ Retryable error detected: ${error.response?.status || 'Network Error'}`);
      return true;
    }
    return false;
  },
  onRetry: (retryCount, error, requestConfig) => {
    console.log(`🔄 Retrying request to ${requestConfig.url} (attempt ${retryCount})`);
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('hw_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.authSite = currentSite();
    config.authToken = token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors and 5xx logging
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Log server errors for debugging
    if (error.response?.status >= 500) {
      console.error(`❌ Server error ${error.response.status} on ${error.config?.url}:`, 
        error.response.data?.detail || error.message);
    }
    
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect && !error.config?.url?.startsWith('/auth/login')) {
      redirectExpiredSession({site: error.config?.authSite, token: error.config?.authToken});
    }
    return Promise.reject(error);
  }
);

export default api;
